module.exports = __webpack_public_path__ + "assets/img/5_1214_big.f531db8b.jpg";